module.exports = __webpack_public_path__ + "img/waves3.1e8101c7.svg";